import { render, staticRenderFns } from "./PackingListIndex.vue?vue&type=template&id=dd38bf46&"
import script from "./PackingListIndex.vue?vue&type=script&lang=js&"
export * from "./PackingListIndex.vue?vue&type=script&lang=js&"
import style0 from "./PackingListIndex.vue?vue&type=style&index=0&id=dd38bf46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports